import { hotTrends, type TrendItem } from "@/mocks/events";

const changeIcon: Record<TrendItem["change"], { icon: string; cls: string }> = {
  up: { icon: "ri-arrow-up-line", cls: "text-accent-600" },
  down: { icon: "ri-arrow-down-line", cls: "text-secondary-600" },
  flat: { icon: "ri-drag-move-line", cls: "text-foreground-400" },
  new: { icon: "ri-sparkling-line", cls: "text-primary-500" },
};

export default function Trending() {
  return (
    <section id="trending" className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex items-end justify-between gap-4">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-bold text-primary-700">
            <i className="ri-fire-line text-sm"></i>
            实时更新
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">今日吃瓜热榜</h2>
          <p className="mt-2 text-sm text-foreground-600">热度综合全网讨论与多平台指数，每 30 分钟刷新一次。</p>
        </div>
        <span className="hidden items-center gap-1.5 whitespace-nowrap text-xs text-foreground-500 sm:flex">
          <i className="ri-time-line text-sm"></i> 更新于 12:30
        </span>
      </div>

      <div className="mt-7 grid gap-3 md:grid-cols-2">
        {hotTrends.map((t) => {
          const ch = changeIcon[t.change];
          const isTop = t.rank <= 3;
          return (
            <a
              key={t.id}
              href="#timeline"
              className={`flex items-center gap-4 rounded-2xl border p-4 transition-colors ${
                isTop
                  ? "border-primary-200 bg-primary-50/70 hover:border-primary-300"
                  : "border-background-200 bg-background-50 hover:border-background-300"
              }`}
            >
              <span
                className={`flex h-9 w-8 shrink-0 items-center justify-center rounded-lg text-base font-black ${
                  isTop ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                }`}
              >
                {t.rank}
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className="whitespace-nowrap rounded bg-secondary-100 px-1.5 py-0.5 text-[11px] font-medium text-secondary-800">
                    {t.tag}
                  </span>
                  <span className="whitespace-nowrap rounded bg-background-100 px-1.5 py-0.5 text-[11px] font-medium text-foreground-500">
                    {t.status}
                  </span>
                </div>
                <p className="mt-1.5 truncate text-sm font-bold text-foreground-900 md:text-base">{t.title}</p>
              </div>
              <div className="flex shrink-0 flex-col items-end gap-1.5">
                <span className="text-sm font-black text-primary-600">{t.heat}</span>
                <span className={`flex h-5 w-5 items-center justify-center ${ch.cls}`}>
                  <i className={`${ch.icon} text-base`}></i>
                </span>
              </div>
            </a>
          );
        })}
      </div>
    </section>
  );
}